import { useDecision } from '@optimizely/react-sdk'
import { Link, matchPath, Route, Switch, useLocation } from 'react-router-dom'

import { NavVertical, Sidebar } from '@tribeplatform/react-ui-kit/Sidebar'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

import { FeaturesList } from '../../../lib/optimizely/feature.list'
import { MainSidebarContent } from './MainSidebarContent'
import { NestedSidebarContent } from './NestedSidebarContent'
import { virtualSidebarRoot, sidebars } from './sidebars'

export const AdminSidebar = ({ onSelect = null }) => {
  const location = useLocation()

  const [decisionPageCustomizer] = useDecision(FeaturesList.PageCustomizer)

  return (
    <div className="flex flex-1">
      <NavVertical size="lg" collapsed className="p-3 h-screen overflow-auto">
        <NavVertical.Group>
          {sidebars.map(item => {
            const active = !!matchPath(location.pathname, {
              path: item.path,
              exact: item.exact || false,
              strict: false,
            })

            if (
              item.featureFlag === FeaturesList.PageCustomizer &&
              !decisionPageCustomizer.enabled
            )
              return null

            const navItem = (
              <NavVertical.Item
                key={item.path}
                active={active}
                as={Link}
                leadingIcon={item.icon}
                onClick={() => {
                  if (typeof onSelect === 'function') onSelect(item)
                }}
                to={
                  item?.children?.length ? item.children?.[0]?.path : item.path
                }
              />
            )
            if (active) return navItem
            return (
              <Tooltip key={item.path} placement="right">
                <Tooltip.Trigger>{navItem}</Tooltip.Trigger>
                <Tooltip.Panel>{item.title}</Tooltip.Panel>
              </Tooltip>
            )
          })}
        </NavVertical.Group>
      </NavVertical>
      <Switch>
        <Route path="/manage/editor/spaces/:id">
          <Sidebar className="h-screen overflow-auto min-w-80 w-80 flex-grow">
            <Sidebar.Content>
              <NestedSidebarContent sidebar={virtualSidebarRoot} />
            </Sidebar.Content>
          </Sidebar>
        </Route>
        <Route path="/manage/editor">
          <Sidebar className="h-screen overflow-auto min-w-80 w-80 flex-grow">
            <Sidebar.Content>
              <NestedSidebarContent sidebar={virtualSidebarRoot} />
            </Sidebar.Content>
          </Sidebar>
        </Route>
        <Route path="/manage">
          <Sidebar className="h-screen overflow-auto min-w-80 w-80 flex-grow">
            <Sidebar.Content>
              {sidebars
                .filter(
                  item =>
                    !!matchPath(location.pathname, {
                      path: item.path,
                      exact: item.exact || false,
                      strict: false,
                    }),
                )
                .map(item => {
                  if (item.component) return item.component
                  return (
                    <MainSidebarContent
                      key={item.path}
                      sidebar={item}
                      onSelect={onSelect}
                    />
                  )
                })}
            </Sidebar.Content>
          </Sidebar>
        </Route>
      </Switch>
    </div>
  )
}
